import Joi from "joi-browser";

function errorsAsString(errors) {
    let stringError = "";
    let err = errors[0];
    switch (err.type) {
        case "string.max":
            stringError = `can't exceed ${err.context.limit} letters.`;
            break;
        case "string.min":
            stringError = `can't be less than ${err.context.limit} letters.`;
            break;
        case "any.empty":
            stringError = "can't be an empty field.";
            break;
        case "string.alphanum":
            stringError = "should be an alphabetical characters only.";
            break;
        default:
            stringError = "is required";
            break;
    }

    return {
        template: " {{message}}",
        context: {
            errors: errors.length,
            message: stringError,
        },
    };
}

const UserProfileSchema = Joi.object().keys({
    firstname: Joi.string()
        .trim()
        .max(256)
        .min(3)
        .alphanum()
        .required()
        .label("First Name")
        .error((errors) => {
            return errorsAsString(errors);
        }),
    lastname: Joi.string()
        .trim()
        .max(256)
        .min(3)
        .alphanum()
        .required()
        .label("Last Name")
        .error((errors) => {
            return errorsAsString(errors);
        }),
});

export default { UserProfileSchema };
